import React from 'react';
import {
    TextInput,
    SelectInput,
    ReferenceInput,
    AutocompleteInput,
} from 'react-admin';
import CustomTableCreate from './CustomTableCreate';
import MyInputFile from '../fields/MyInputFile';
import utils from "../utils/utils";

class SellingPointCreate extends CustomTableCreate {

    customHandled(fields, fieldName, fieldList) {

        if (fieldName === "code") {
            return true;
        } else if (fieldName === 'logo') {
            fieldList.push(<MyInputFile source={fieldName} label="Logo" folder="selling-point-logo" />);
            return true;
        } else if (fieldName === 'descriptionEN' || fieldName === 'descriptionCN' || fieldName === 'openingEN' || fieldName === 'openingCN') {
            let fieldLabel = fieldName.replace(/([A-Z])/g, ' $1').trim();
            fieldLabel = fieldLabel.charAt(0).toUpperCase() + fieldLabel.slice(1);
            fieldList.push(<TextInput label={fieldLabel} source={fieldName} fullWidth multiline />);
            return true;
        } else if (fieldName === "category") {
            fieldList.push(<SelectInput source={fieldName} label={"Category"} choices={this.transformInChoices(fields[fieldName].enum)} />);
            return true;
        } else if (fieldName === "type") {
            const plural = utils.getPlural(fields[fieldName].ref);
            fieldList.push(<ReferenceInput label={"Type"} source={"type"} reference={"selling-point-types"} allowEmpty>
                <AutocompleteInput optionText={utils.displayFieldForPlural(plural)} />
            </ReferenceInput>);
            return true;
        } else if (fieldName === "tag") {
            fieldList.push(<TextInput label={"Jingsocial tag ID for analytics"} source={fieldName} key={"Jingsocial tag ID for analytics"}/>);
            return true;
        }
        return false;
    }
}

export default SellingPointCreate;
